"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInfoIconSlots = exports.default = exports.InfoIcon = void 0;
var _mui = require("@ori-ui/mui");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _infoIconClasses = require("./infoIconClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getInfoIconSlots = ownerState => {
  const {
    autoResize,
    isText
  } = ownerState;
  return {
    root: ['root', autoResize && 'autoResize'],
    content: ['content', isText ? 'contentText' : 'contentIcon', autoResize && 'contentAutoResize']
  };
};
exports.getInfoIconSlots = getInfoIconSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getInfoIconSlots(ownerState);
  const composedClasses = (0, _mui.unstable_composeClasses)(slots, _infoIconClasses.getInfoIconUtilityClass, classes);
  return composedClasses;
};
const InfoIconRoot = (0, _mui.styled)('span', {
  name: 'InfoIcon',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, ownerState.autoResize && styles.autoResize]
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  boxSizing: 'border-box',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  justifyItems: 'center',
  overflow: 'hidden',
  borderRadius: '50%',
  textDecoration: 'none',
  fontWeight: 'normal',
  width: '3.5rem',
  height: '3.5rem',
  background: theme.palette.offer.light,
  color: theme.palette.offer.main,
  ...(ownerState.autoResize && {
    [theme.breakpoints.up('sm')]: {
      width: '4.5rem',
      height: '4.5rem'
    }
  })
}));
const InfoIconContent = (0, _mui.styled)('span', {
  name: 'InfoIcon',
  slot: 'Content',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.content, ownerState.isText ? styles.contentText : styles.contentIcon, ownerState.autoResize && styles.contentAutoResize]
})(({
  theme,
  ownerState
}) => ({
  display: 'block',
  overflow: 'hidden',
  lineHeight: 1,
  color: theme.palette.offer.main,
  fontSize: '2.4rem',
  ...(ownerState.isText && {
    textAlign: 'center',
    fontSize: '1rem',
    lineHeight: 1.4
  }),
  ...(ownerState.autoResize && {
    [theme.breakpoints.up('sm')]: {
      fontSize: '3.4rem',
      ...(ownerState.isText && {
        fontSize: '1.2rem'
      })
    }
  })
}));
const InfoIcon = exports.InfoIcon = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _mui.useThemeProps)({
    props: inProps,
    name: 'InfoIcon'
  });
  const {
    autoResize = false,
    children,
    className,
    isText = false,
    ...other
  } = props;
  const ownerState = {
    ...props,
    autoResize,
    isText
  };
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(InfoIconRoot, {
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx.default)(classes.root, className),
    ...other,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(InfoIconContent, {
      ownerState: ownerState,
      className: classes.content,
      children: children
    })
  });
});
var _default = exports.default = InfoIcon;
